import { Package, PackageHost } from '../../Container';
import { inTools } from '../../canvas/tooling/ToolManager';
import { inLensAspectProvider } from '../lens/LensReflector';
import { ParticleManager } from './ParticleManager';
import { particleTool } from './ParticleTool';
import { inVoterCommands } from './VoterCommands';
import { VoterController } from './VoterController';
import { VoterLensAspectProvider } from './VoterLensAspectProvider';
import { voterTool } from './VoterTool';

export class VoterPackage implements Package {

    public install = (host: PackageHost) => host
        .register(ParticleManager, 'singleton', 'startable')
        .register(VoterController, 'singleton', 'startable')
        .plug(inVoterCommands())
        .plug(inTools(voterTool, particleTool))
        .plug(inLensAspectProvider(VoterLensAspectProvider))
        ;
}
